// extracted by mini-css-extract-plugin
var _1 = "InstallBanner-module__atLogo___pHyTt";
var _2 = "InstallBanner-module__background___SmIH5";
var _3 = "InstallBanner-module__browserImageContainer___LsXF5";
var _4 = "InstallBanner-module__browserLogo___h0gwG";
var _5 = "InstallBanner-module__button___TMFWU";
var _6 = "InstallBanner-module__close___hFxFS";
var _7 = "InstallBanner-module__container___OjaC0";
var _8 = "InstallBanner-module__contentContainer___nxEp5";
var _9 = "InstallBanner-module__divider___o7ho5";
var _a = "InstallBanner-module__nameAndRatingContainer___qPEQw";
var _b = "InstallBanner-module__noPointer___FnDlf";
var _c = "InstallBanner-module__optionContainer___Waowc";
var _d = "InstallBanner-module__optionInfo___Mg4vH";
var _e = "InstallBanner-module__ratingContainer___XNNcZ";
var _f = "InstallBanner-module__ratingNumber___woVyM";
var _10 = "InstallBanner-module__slideIn___uG9C1";
var _11 = "InstallBanner-module__variantContainer___Of6kg";
export { _1 as "atLogo", _2 as "background", _3 as "browserImageContainer", _4 as "browserLogo", _5 as "button", _6 as "close", _7 as "container", _8 as "contentContainer", _9 as "divider", _a as "nameAndRatingContainer", _b as "noPointer", _c as "optionContainer", _d as "optionInfo", _e as "ratingContainer", _f as "ratingNumber", _10 as "slideIn", _11 as "variantContainer" }
